'use strict';

var cache = {};

/**
 * Add click event to trigger a redirect
 * @param {jquery} $btn - redirect to cart button
 */
function redirectToCart($btn) {
    $btn.on('click', function () {
        var $this = $(this);
        var cartUrl = $this.data('cart-url');

        window.location = cartUrl;
    });
}

/**
 * Initializes the modal slider.
 * @param {jQuery} $modalSlider - The jQuery element containing the slider.
 */
function initModalSlider($modalSlider) {
    if ($modalSlider.length > 0 && $modalSlider.hasClass('slick-initialized')) {
        $modalSlider[0].slick.refresh();
        $(window).trigger('alignTiles', {container: $modalSlider, resetHeight: true});
    }
}

/**
 * Updates the content of the "Add to Bag" modal with the given data.
 * @param {jQuery} $element - The jQuery element containing the modal.
 * @param {Object} data - The data to update the modal with.
 */
function updateContent($element, data) {
    cache.$document.trigger('addToBagModal:beforeShowModal', {$element, data});
    $element.find('.js-add-to-bag-modal-content').html(data.addToBagModalTemplate);
    cache.$document.trigger('addToBagModal:afterShowModal');
}

module.exports = {
    initCache: function () {
        cache.$document = $(document);
        cache.$body = $('body');
        cache.$addToBagModal = $('#addToBagModal');
        cache.$realTimeInventoryModal = $('#realTimeInventoryModal');
        cache.$redirectToCartBtn = $('.js-redirect-to-cart');
        cache.$jatcRecSlider = $('.js-jatc-recommendation-slider');
    },
    addToBagModal: function () {
        cache.$body.on('product:afterAddToCart', function (e, data) {
            $('#shoppableModal').modal('hide');

            cache.$addToBagModal.off('show.bs.modal.jatc').on('show.bs.modal.jatc', function () {
                var $this = $(this);

                updateContent($this, data);

                if (cache.$addToBagModal.hasClass('bbw-add-to-bag-right-modal') && typeof zE === 'function') {
                    zE('webWidget', 'hide');  // eslint-disable-line
                }
            });

            cache.$addToBagModal.off('update.modal').on('update.modal', function () {
                var $this = $(this);

                updateContent($this, data);
            });

            cache.$addToBagModal.off('shown.bs.modal.jatc').on('shown.bs.modal.jatc', function () {
                initModalSlider(cache.$jatcRecSlider);
                initModalSlider($('.js-einstein-jatc-recommendation-slider'));
            });

            cache.$addToBagModal.off('hide.bs.modal.jatc').on('hide.bs.modal.jatc', function () {
                var $this = $(this);
                var $cartPage = $('.cart-page');

                $this.find('.js-add-to-bag-modal-content').html('');

                if ($this.hasClass('bbw-add-to-bag-right-modal')) {
                    var $icon = $this.find('.modal-title .back-btn');
                    $icon.addClass('d-none');
                } else {
                    var $modalContent = $this.find('.modal-body');
                    $modalContent.removeClass('modal-with-scroll');
                }

                if ($cartPage.length) {
                    location.reload();
                }

                if (cache.$addToBagModal.hasClass('bbw-add-to-bag-right-modal') && typeof zE === 'function') {
                    zE('webWidget', 'show');  // eslint-disable-line
                }
            });

            redirectToCart(cache.$redirectToCartBtn);

            if (!data.error && $('#chooseBonusProductModal').length === 0) {
                if (cache.$addToBagModal.hasClass('show')) {
                    cache.$addToBagModal.trigger('update.modal');
                }

                cache.$addToBagModal.modal('show');
            }
        });
    },
    realTimeInventoryModal: function () {
        cache.$body.on('product:notAddedToCart', function () {
            cache.$realTimeInventoryModal.modal('show');
        });

        redirectToCart(cache.$redirectToCartBtn);
    }
};
